module.exports = __webpack_public_path__ + "img/9788930312462.29046ca5.jpg";